module.exports = __webpack_public_path__ + "static/media/SocialMediaMarketing.a3be5161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/MunafaMart/SocialMediaMarketing.jpg
// module id = 338
// module chunks = 0